import type { ReactElement } from 'react'

export interface CounterProps {
  className?: string
  disabled?: boolean
  leadingIconButton?: ReactElement
  loading?: boolean
  quantity?: string
  size?: CounterSizeType
  trailingIconButton?: ReactElement
  variant?: CounterVariantType
}

export enum CounterVariant {
  neutral = 'neutral',
  floating = 'floating',
}

export enum CounterSize {
  small = 's',
  medium = 'm',
  large = 'l',
}

export type CounterSizeType = `${CounterSize}`
export type CounterVariantType = `${CounterVariant}`
